/* Model info på Slider Halskæde og Krystal Stud (guld + sølv).
 *
 * En lille pille i nederste højre hjørne af de medier, hvor en model bærer
 * smykket. Et tryk lader et kort glide op over billedets nederste del med
 * produktets verificerede modeloplysninger. Et tryk mere lukker det.
 *
 * Mobil (<=699 px), eller alle skærme ved eksplicit allScreens i produktets config.
 * Teksten kommer lokaliseret fra Liquid — ét sprog pr.
 * marked, ikke oversat i browseren. ?modelinfo=off slår den fra.
 *
 * Slider-guld-galleriet ombygges af pkm-slider-pdp-mobile.js (skjorte- og Rosa-
 * sliden findes først efter ombygningen), så vi lægger piller på i flere
 * omgange: hver omgang giver de medier, der har data og mangler en pille, en.
 */
(() => {
  const CFG = window.PKM_SLIDER_MODEL_INFO || window.PKM_STUD_MODEL_INFO || window.PKM_ECHO_MODEL_INFO || window.PKM_CHUNKY_MODEL_INFO;
  if (!CFG || !CFG.entries) return;

  const params = new URLSearchParams(location.search);
  if (params.get('modelinfo') === 'off') return;

  const MOBILE = matchMedia('(max-width: 699px)');
  const ALL_SCREENS = CFG.allScreens === true;
  const ENTRIES = CFG.entries;
  const LABEL = CFG.label || 'Model info';
  const WANTED = Object.keys(ENTRIES).length;

  let mounted = [];
  let boundCarousel = null;

  function card(slide, text) {
    const wrap = document.createElement('div');
    wrap.className = 'pkm-model-info';
    wrap.dataset.mediaId = slide.dataset.mediaId || '';
    wrap.innerHTML =
      '<div class="pkm-model-info__card" hidden><p></p></div>' +
      '<button type="button" class="pkm-model-info__trigger" aria-expanded="false"></button>';

    const box = wrap.querySelector('.pkm-model-info__card');
    const btn = wrap.querySelector('.pkm-model-info__trigger');
    box.querySelector('p').textContent = text;
    btn.textContent = LABEL;

    function open(state) {
      box.hidden = !state;
      btn.setAttribute('aria-expanded', String(state));
      wrap.classList.toggle('is-open', state);
    }
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();          // galleriet må ikke opfatte trykket som et swipe
      open(box.hidden);
    });
    box.addEventListener('click', (e) => {
      e.stopPropagation();
      open(false);
    });

    slide.appendChild(wrap);
    return { wrap, close: () => open(false) };
  }

  function findCarousel() {
    const gallery =
      document.querySelector('product-gallery[data-pkm-slider-product-metal]') ||
      document.querySelector('product-gallery');
    return gallery && gallery.querySelector('media-carousel');
  }

  function closeAll() {
    mounted.forEach((m) => m.close());
  }

  function mount() {
    if (!ALL_SCREENS && !MOBILE.matches) return;
    const carousel = findCarousel();
    if (!carousel) return;

    const slides = [...carousel.querySelectorAll(':scope > .product-gallery__media')];
    slides.forEach((slide) => {
      const id = slide.dataset.mediaId || '';
      const text = ENTRIES[id];
      const existing = slide.querySelector('.pkm-model-info');
      // En klonet slide kan arve en pille uden lyttere — smid den ud.
      if (existing && (!text || existing.dataset.mediaId !== id)) {
        existing.remove();
        mounted = mounted.filter((m) => m.wrap !== existing);
      } else if (existing) {
        return;
      }
      if (!text) return;                       // intet medie uden data får en pille
      mounted.push(card(slide, text));
    });

    // Luk et åbent kort, når man swiper videre.
    if (boundCarousel !== carousel) {
      carousel.addEventListener('carousel:change', closeAll);
      // settle fires after layout/scroll even without a media change; it must
      // not immediately close a card that the customer has just opened.
      boundCarousel = carousel;
    }
  }

  function unmount() {
    mounted.forEach((m) => m.wrap.remove());
    mounted = [];
  }

  function sync() {
    if (ALL_SCREENS || MOBILE.matches) mount();
    else unmount();
  }

  MOBILE.addEventListener('change', sync);

  // Prøv indtil alle medier med data har en pille, eller ca. 10 sekunder er gået.
  let tries = 0;
  const retry = setInterval(() => {
    sync();
    if (((ALL_SCREENS || MOBILE.matches) && mounted.length >= WANTED) || ++tries > 40) {
      clearInterval(retry);
    }
  }, 250);
})();
